module.exports = __webpack_public_path__ + "img/Download.6916bfb2.svg";